export const blockIconsAudioandvideoFastRewindNew = (
	<span className='material-symbols-outlined'>fast_rewind</span>
);
